import React, { FunctionComponent } from 'react';
import { ApiDataRequest, performApiRequest, getApiDataRequest } from 'react-api-data/lib';
import { withTranslation, WithTranslation } from 'react-i18next';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';

// constants
import { ReduxState } from 'createStore';

// components
import LoaderButton from 'components/utils/LoaderButton';

interface InProps {
    ipAddress: string;
}

interface EnhancedProps {
    unblockBGPSession: () => void;
    unblockBGPSessionRequest: ApiDataRequest;
}

type Props = InProps & WithTranslation & EnhancedProps;

const mapStateToProps = (state: ReduxState, ownProps: Props) => ({
    unblockBGPSessionRequest: getApiDataRequest(state.apiData, 'putUnblockBGPSession', {
        ip: ownProps.ipAddress
    }),
});

const mapDispatchToProps = (dispatch: any, ownProps: InProps) => ({
    unblockBGPSession: () => {
        dispatch(performApiRequest('putUnblockBGPSession', { ip: ownProps.ipAddress }));
    }
});

const UnblockBGPSession: FunctionComponent<Props> = ({
    t, ipAddress, unblockBGPSession, unblockBGPSessionRequest
}) => {

    return (
            <LoaderButton
                data-test="unblock-btn"
                className="mt-2"
                loading={get(unblockBGPSessionRequest, 'networkStatus') === 'loading'}
                onClick={() => unblockBGPSession()}
            >
                {t('quickdebug.unblockBGPsessionsForIP', { ip: ipAddress })}
            </LoaderButton>
    );
};

export default compose<Props, InProps>(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(UnblockBGPSession);